import * as DropdownMenu from '@radix-ui/react-dropdown-menu';
import { ArrowUpIcon, BulletedList, NumberedList } from '@sketchnote/icons';
import * as React from 'react';
import { AlignStyle, FontStyle, ListType, TextWeight, useTldrawApp } from 'sn-wb-tldraw';

export const editorIcons = {
  fontIncrement: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.79976 1C3.48348 1 3.20441 1.23315 3.11186 1.57454L0.0315512 12.9495C-0.0352357 13.195 0.00531344 13.4621 0.140795 13.6688C0.276754 13.8762 0.49095 13.9973 0.718979 13.9973H1.89968C2.22312 13.9973 2.50648 13.7545 2.59283 13.4029L3.26738 10.6546H6.56522L7.30035 13.4217C7.39147 13.7658 7.67149 14 7.98921 14H9.28058C9.50909 14 9.72424 13.8767 9.85972 13.671C9.9952 13.4615 10.0353 13.1945 9.96801 12.9473L6.84191 1.5713C6.7484 1.23154 6.47028 1 6.15495 1H3.79976ZM3.64281 8.44688C3.64281 8.44688 4.31354 5.56397 4.66704 4.03152C4.69041 3.92975 4.77104 3.85868 4.86406 3.8576C4.95708 3.85652 5.03914 3.92544 5.06442 4.02614L6.1893 8.44688H3.64281Z"
        fill="white"
      />
      <path
        d="M11.8099 2.24323V0.419895C11.8099 0.187884 11.6164 0 11.377 0H10.6226C10.3836 0 10.1901 0.187884 10.1901 0.419895V2.24323H8.43249C8.19305 2.24323 8 2.43112 8 2.66313V3.33778C8 3.56979 8.19305 3.75768 8.43249 3.75768H10.1901V5.58056C10.1901 5.81257 10.3836 6 10.6226 6H11.377C11.6164 6 11.8099 5.81212 11.8099 5.58056V3.75768H13.5675C13.8065 3.75768 14 3.56979 14 3.33778V2.66313C14 2.43112 13.8065 2.24323 13.5675 2.24323H11.8099Z"
        fill="white"
      />
    </svg>
  ),
  fontDecrement: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.79903 6C7.48275 6 7.20367 6.23315 7.11113 6.57454L4.03082 17.9495C3.96403 18.195 4.00458 18.4621 4.14006 18.6688C4.27602 18.8762 4.49022 18.9973 4.71825 18.9973H5.89894C6.22238 18.9973 6.50575 18.7545 6.5921 18.4029L7.26664 15.6546H10.5645L11.2996 18.4217C11.3907 18.7658 11.6708 19 11.9885 19H13.2798C13.5084 19 13.7235 18.8767 13.859 18.671C13.9945 18.4615 14.0345 18.1945 13.9673 17.9473L10.8412 6.5713C10.7477 6.23154 10.4696 6 10.1542 6H7.79903ZM7.64208 13.4469C7.64208 13.4469 8.31281 10.564 8.66631 9.03152C8.68968 8.92975 8.7703 8.85868 8.86333 8.8576C8.95635 8.85652 9.0384 8.92544 9.06369 9.02614L10.1886 13.4469H7.64208Z"
        fill="white"
      />
      <rect x="11.9993" y="5" width="6" height="2" rx="0.5" fill="white" />
    </svg>
  ),
  bold: (
    <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.3374 4.093C11.3356 3.00804 10.9038 1.96804 10.1366 1.20086C9.36938 0.433671 8.32939 0.0018508 7.24442 0L1.84442 0C1.53013 0.000529447 1.22888 0.125685 1.00673 0.348017C0.784589 0.570349 0.659688 0.871707 0.659424 1.186V12.814C0.659689 13.1285 0.784727 13.43 1.00709 13.6523C1.22945 13.8747 1.53096 13.9997 1.84542 14H7.24542C8.33039 13.9981 9.37038 13.5663 10.1376 12.7991C10.9048 12.032 11.3366 10.992 11.3384 9.907C11.3371 9.36408 11.2266 8.82697 11.0136 8.32759C10.8006 7.8282 10.4894 7.37673 10.0984 7C10.4893 6.62325 10.8004 6.17176 11.0132 5.67236C11.2261 5.17296 11.3363 4.63586 11.3374 4.093V4.093ZM7.24442 5.814H3.03242V2.373H7.24442C7.69355 2.38383 8.12063 2.56985 8.43445 2.89132C8.74827 3.2128 8.92394 3.64425 8.92394 4.0935C8.92394 4.54275 8.74827 4.9742 8.43445 5.29568C8.12063 5.61715 7.69355 5.80317 7.24442 5.814ZM7.24442 11.627H3.03242V8.186H7.24442C7.69355 8.19683 8.12063 8.38285 8.43445 8.70432C8.74827 9.0258 8.92394 9.45725 8.92394 9.9065C8.92394 10.3558 8.74827 10.7872 8.43445 11.1087C8.12063 11.4302 7.69355 11.6162 7.24442 11.627V11.627Z"
        fill="white"
      />
    </svg>
  ),
  italic: (
    <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9.58742 1C9.58479 0.733868 9.47722 0.479532 9.28809 0.292278C9.09896 0.105024 8.84357 -1.30441e-05 8.57743 1.21501e-09L4.07742 1.21501e-09C3.81128 -1.30441e-05 3.55589 0.105024 3.36676 0.292278C3.17763 0.479532 3.07006 0.733868 3.06742 1V1.463C3.06742 1.73087 3.17384 1.98777 3.36325 2.17718C3.55266 2.36659 3.80956 2.473 4.07742 2.473H5.14342L2.57242 11.526H1.41942C1.15328 11.526 0.897886 11.631 0.708759 11.8183C0.519632 12.0055 0.412059 12.2599 0.409424 12.526V12.989C0.409293 13.1217 0.43532 13.2532 0.486019 13.3758C0.536717 13.4985 0.611092 13.6099 0.704893 13.7038C0.798693 13.7977 0.910079 13.8722 1.03268 13.923C1.15529 13.9738 1.28671 14 1.41942 14H5.99142C6.25877 13.9992 6.5149 13.8924 6.70366 13.7031C6.89243 13.5138 6.99843 13.2573 6.99842 12.99V12.527C6.99579 12.2609 6.88822 12.0065 6.69909 11.8193C6.50996 11.632 6.25457 11.527 5.98842 11.527H4.85942L7.43042 2.474H8.57743C8.84529 2.474 9.10219 2.36759 9.2916 2.17818C9.48101 1.98877 9.58742 1.73187 9.58742 1.464V1Z"
        fill="white"
      />
    </svg>
  ),
  underline: (
    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.88248 10.094C9.24547 10.0924 10.5522 9.55026 11.516 8.58648C12.4797 7.6227 13.0219 6.31599 13.0235 4.953V1.205C13.0235 0.885414 12.8965 0.578918 12.6705 0.352936C12.4446 0.126955 12.1381 0 11.8185 0C11.4989 0 11.1924 0.126955 10.9664 0.352936C10.7404 0.578918 10.6135 0.885414 10.6135 1.205V4.953C10.6135 5.67731 10.3257 6.37195 9.81359 6.88411C9.30142 7.39627 8.60678 7.684 7.88248 7.684C7.15817 7.684 6.46353 7.39627 5.95137 6.88411C5.43921 6.37195 5.15148 5.67731 5.15148 4.953V1.205C5.14244 0.891292 5.01147 0.593463 4.78638 0.374763C4.56129 0.156064 4.25982 0.0337239 3.94598 0.0337239C3.63214 0.0337239 3.33066 0.156064 3.10557 0.374763C2.88048 0.593463 2.74951 0.891292 2.74048 1.205V4.953C2.74207 6.31616 3.28435 7.62303 4.24835 8.58683C5.21235 9.55064 6.51931 10.0927 7.88248 10.094Z"
        fill="white"
      />
      <path
        d="M13.9875 11.5811H2.00954C1.74361 11.5821 1.48871 11.6874 1.29965 11.8744C1.11059 12.0614 1.00246 12.3152 0.998536 12.5811V12.9881C0.998404 13.1209 1.02446 13.2525 1.07521 13.3753C1.12595 13.498 1.2004 13.6096 1.2943 13.7036C1.38819 13.7976 1.49969 13.8721 1.62241 13.923C1.74514 13.9739 1.87669 14.0001 2.00954 14.0001H13.9875C14.2553 14.0001 14.5122 13.8938 14.7017 13.7046C14.8913 13.5155 14.998 13.2588 14.9985 12.9911V12.5831C14.9951 12.3168 14.8872 12.0626 14.6981 11.8751C14.509 11.6877 14.2538 11.5821 13.9875 11.5811Z"
        fill="white"
      />
    </svg>
  ),
  strike: (
    <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.311 7.09998H6.49854C5.07001 7.09998 3.9486 6.06948 3.9486 4.84995C3.9486 3.63054 5.07 2.60004 6.49854 2.60004C7.92707 2.60004 9.04847 3.63054 9.04847 4.84995C9.04847 5.34419 9.44279 5.75003 9.93605 5.75003C10.4292 5.75003 10.8235 5.34417 10.8235 4.84995C10.8235 2.60445 8.87078 0.8 6.49854 0.8C4.12629 0.8 2.17357 2.60445 2.17357 4.84995C2.17357 5.68282 2.44388 6.45692 2.90399 7.09998H1.68611C1.1929 7.09998 0.798535 7.50564 0.798535 7.99994C0.798535 8.49418 1.19285 8.90002 1.68611 8.90002H6.49854C7.92707 8.90002 9.04847 9.93052 9.04847 11.1499C9.04847 12.3695 7.92706 13.4 6.49854 13.4C5.07001 13.4 3.9486 12.3695 3.9486 11.1499C3.9486 10.6556 3.55423 10.25 3.06102 10.25C2.56791 10.25 2.17357 10.6557 2.17357 11.1499C2.17357 13.3955 4.12628 15.2 6.49854 15.2C8.87079 15.2 10.8235 13.3955 10.8235 11.1499C10.8235 10.3172 10.5532 9.54307 10.0931 8.90002H11.311C11.8042 8.90002 12.1985 8.49418 12.1985 7.99994C12.1985 7.50564 11.8042 7.09998 11.311 7.09998Z"
        fill="white"
        stroke="white"
        strokeWidth="0.4"
      />
    </svg>
  ),
  start: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.74996 2.33317H12.25C12.4047 2.33317 12.553 2.27171 12.6624 2.16232C12.7718 2.05292 12.8333 1.90455 12.8333 1.74984C12.8333 1.59513 12.7718 1.44675 12.6624 1.33736C12.553 1.22796 12.4047 1.1665 12.25 1.1665H1.74996C1.59525 1.1665 1.44688 1.22796 1.33748 1.33736C1.22808 1.44675 1.16663 1.59513 1.16663 1.74984C1.16663 1.90455 1.22808 2.05292 1.33748 2.16232C1.44688 2.27171 1.59525 2.33317 1.74996 2.33317Z"
        fill="#fff"
      />
      <path
        d="M1.74996 5.83317H8.74996C8.90467 5.83317 9.05304 5.77171 9.16244 5.66232C9.27184 5.55292 9.33329 5.40455 9.33329 5.24984C9.33329 5.09513 9.27184 4.94675 9.16244 4.83736C9.05304 4.72796 8.90467 4.6665 8.74996 4.6665H1.74996C1.59525 4.6665 1.44688 4.72796 1.33748 4.83736C1.22808 4.94675 1.16663 5.09513 1.16663 5.24984C1.16663 5.40455 1.22808 5.55292 1.33748 5.66232C1.44688 5.77171 1.59525 5.83317 1.74996 5.83317Z"
        fill="#fff"
      />
      <path
        d="M1.74996 9.33317H12.25C12.4047 9.33317 12.553 9.27171 12.6624 9.16232C12.7718 9.05292 12.8333 8.90455 12.8333 8.74984C12.8333 8.59513 12.7718 8.44675 12.6624 8.33736C12.553 8.22796 12.4047 8.1665 12.25 8.1665H1.74996C1.59525 8.1665 1.44688 8.22796 1.33748 8.33736C1.22808 8.44675 1.16663 8.59513 1.16663 8.74984C1.16663 8.90455 1.22808 9.05292 1.33748 9.16232C1.44688 9.27171 1.59525 9.33317 1.74996 9.33317Z"
        fill="#fff"
      />
      <path
        d="M1.74996 12.8332H8.74996C8.90467 12.8332 9.05304 12.7717 9.16244 12.6623C9.27184 12.5529 9.33329 12.4045 9.33329 12.2498C9.33329 12.0951 9.27184 11.9468 9.16244 11.8374C9.05304 11.728 8.90467 11.6665 8.74996 11.6665H1.74996C1.59525 11.6665 1.44688 11.728 1.33748 11.8374C1.22808 11.9468 1.16663 12.0951 1.16663 12.2498C1.16663 12.4045 1.22808 12.5529 1.33748 12.6623C1.44688 12.7717 1.59525 12.8332 1.74996 12.8332Z"
        fill="#fff"
      />
    </svg>
  ),
  middle: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.25 1.1665H1.74996C1.59525 1.1665 1.44688 1.22796 1.33748 1.33736C1.22808 1.44675 1.16663 1.59513 1.16663 1.74984C1.16663 1.90455 1.22808 2.05292 1.33748 2.16232C1.44688 2.27171 1.59525 2.33317 1.74996 2.33317H12.25C12.4047 2.33317 12.553 2.27171 12.6624 2.16232C12.7718 2.05292 12.8333 1.90455 12.8333 1.74984C12.8333 1.59513 12.7718 1.44675 12.6624 1.33736C12.553 1.22796 12.4047 1.1665 12.25 1.1665Z"
        fill="white"
      />
      <path
        d="M9.91667 5.83317C10.0714 5.83317 10.2197 5.77171 10.3291 5.66232C10.4385 5.55292 10.5 5.40455 10.5 5.24984C10.5 5.09513 10.4385 4.94675 10.3291 4.83736C10.2197 4.72796 10.0714 4.6665 9.91667 4.6665H4.08333C3.92862 4.6665 3.78025 4.72796 3.67085 4.83736C3.56146 4.94675 3.5 5.09513 3.5 5.24984C3.5 5.40455 3.56146 5.55292 3.67085 5.66232C3.78025 5.77171 3.92862 5.83317 4.08333 5.83317H9.91667Z"
        fill="white"
      />
      <path
        d="M12.25 8.1665H1.74996C1.59525 8.1665 1.44688 8.22796 1.33748 8.33736C1.22808 8.44675 1.16663 8.59513 1.16663 8.74984C1.16663 8.90455 1.22808 9.05292 1.33748 9.16232C1.44688 9.27171 1.59525 9.33317 1.74996 9.33317H12.25C12.4047 9.33317 12.553 9.27171 12.6624 9.16232C12.7718 9.05292 12.8333 8.90455 12.8333 8.74984C12.8333 8.59513 12.7718 8.44675 12.6624 8.33736C12.553 8.22796 12.4047 8.1665 12.25 8.1665Z"
        fill="white"
      />
      <path
        d="M9.91667 12.8332C10.0714 12.8332 10.2197 12.7717 10.3291 12.6623C10.4385 12.5529 10.5 12.4045 10.5 12.2498C10.5 12.0951 10.4385 11.9468 10.3291 11.8374C10.2197 11.728 10.0714 11.6665 9.91667 11.6665H4.08333C3.92862 11.6665 3.78025 11.728 3.67085 11.8374C3.56146 11.9468 3.5 12.0951 3.5 12.2498C3.5 12.4045 3.56146 12.5529 3.67085 12.6623C3.78025 12.7717 3.92862 12.8332 4.08333 12.8332H9.91667Z"
        fill="white"
      />
    </svg>
  ),
  end: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.25 1.1665H1.74996C1.59525 1.1665 1.44688 1.22796 1.33748 1.33736C1.22808 1.44675 1.16663 1.59513 1.16663 1.74984C1.16663 1.90455 1.22808 2.05292 1.33748 2.16232C1.44688 2.27171 1.59525 2.33317 1.74996 2.33317H12.25C12.4047 2.33317 12.553 2.27171 12.6624 2.16232C12.7718 2.05292 12.8333 1.90455 12.8333 1.74984C12.8333 1.59513 12.7718 1.44675 12.6624 1.33736C12.553 1.22796 12.4047 1.1665 12.25 1.1665Z"
        fill="white"
      />
      <path
        d="M12.25 5.83317C12.4047 5.83317 12.553 5.77171 12.6624 5.66232C12.7718 5.55292 12.8333 5.40455 12.8333 5.24984C12.8333 5.09513 12.7718 4.94675 12.6624 4.83736C12.553 4.72796 12.4047 4.6665 12.25 4.6665H5.24996C5.09525 4.6665 4.94688 4.72796 4.83748 4.83736C4.72808 4.94675 4.66663 5.09513 4.66663 5.24984C4.66663 5.40455 4.72808 5.55292 4.83748 5.66232C4.94688 5.77171 5.09525 5.83317 5.24996 5.83317H12.25Z"
        fill="white"
      />
      <path
        d="M1.16663 8.74984C1.16663 8.90455 1.22808 9.05292 1.33748 9.16232C1.44688 9.27171 1.59525 9.33317 1.74996 9.33317H12.25C12.4047 9.33317 12.553 9.27171 12.6624 9.16232C12.7718 9.05292 12.8333 8.90455 12.8333 8.74984C12.8333 8.59513 12.7718 8.44675 12.6624 8.33736C12.553 8.22796 12.4047 8.1665 12.25 8.1665H1.74996C1.59525 8.1665 1.44688 8.22796 1.33748 8.33736C1.22808 8.44675 1.16663 8.59513 1.16663 8.74984Z"
        fill="white"
      />
      <path
        d="M12.8333 12.2498C12.8333 12.0951 12.7718 11.9468 12.6624 11.8374C12.553 11.728 12.4047 11.6665 12.25 11.6665H5.24996C5.09525 11.6665 4.94688 11.728 4.83748 11.8374C4.72808 11.9468 4.66663 12.0951 4.66663 12.2498C4.66663 12.4045 4.72808 12.5529 4.83748 12.6623C4.94688 12.7717 5.09525 12.8332 5.24996 12.8332H12.25C12.4047 12.8332 12.553 12.7717 12.6624 12.6623C12.7718 12.5529 12.8333 12.4045 12.8333 12.2498Z"
        fill="white"
      />
    </svg>
  ),
  defaultList: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7 14C10.8596 14 14 10.8599 14 7C14 5.12866 13.2723 3.37054 11.9508 2.04921C10.6292 0.727742 8.87134 0 7 0C3.14012 0 0 3.14012 0 7C0 8.87134 0.727742 10.6295 2.04921 11.9508C3.37054 13.2723 5.12866 14 7 14ZM7 12.8333C5.6368 12.8333 4.3458 12.3699 3.30688 11.518L11.518 3.30688C12.3699 4.3458 12.8333 5.6368 12.8333 7C12.8333 10.2165 10.2165 12.8333 7 12.8333ZM7 1.16667C8.36292 1.16667 9.65419 1.63009 10.6928 2.48201L2.48201 10.6931C1.63009 9.65419 1.16667 8.3632 1.16667 7C1.16667 3.78355 3.78355 1.16667 7 1.16667Z"
        fill="white"
      />
    </svg>
  ),
  numberedList: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5793_60354)">
        <path
          d="M0.478726 0.954408L0.593752 0.868627V1.71429C0.593752 1.87208 0.726669 2 0.890626 2C1.05458 2 1.1875 1.87208 1.1875 1.71429V0.285707C1.1875 0.176681 1.12301 0.07713 1.0213 0.0291652C0.919553 -0.0188281 0.798311 -0.00690494 0.708777 0.0598822L0.115029 0.50273C-0.0145574 0.599389 -0.038205 0.778867 0.0622305 0.903595C0.162651 1.0283 0.34911 1.05107 0.478726 0.954408Z"
          fill="white"
        />
        <path
          d="M0.618726 11.6665C0.617133 11.6665 0.615594 11.6667 0.614027 11.6667C0.612434 11.6667 0.610908 11.6665 0.609328 11.6665C0.376095 11.6665 0.157674 11.7858 0.039312 11.9779C-0.0374503 12.1024 0.00132245 12.2656 0.125897 12.3423C0.169236 12.369 0.217221 12.3818 0.264648 12.3818C0.353556 12.3818 0.440419 12.337 0.490475 12.2558C0.512748 12.2196 0.559406 12.1963 0.609355 12.1963C0.610948 12.1963 0.612487 12.1961 0.614054 12.1961C0.615647 12.1961 0.617173 12.1963 0.618753 12.1963C0.690551 12.1963 0.751238 12.257 0.751238 12.3287C0.751238 12.3493 0.693989 12.407 0.637655 12.4357L0.640044 12.4345L0.640124 12.4347C0.581201 12.4631 0.532513 12.513 0.507425 12.5789C0.455392 12.7156 0.524071 12.8687 0.660831 12.9207C0.688745 12.9313 0.745079 12.9709 0.751225 12.991C0.751225 13.0628 0.690551 13.1235 0.618739 13.1235C0.60163 13.1235 0.584944 13.1252 0.568737 13.1283C0.538008 13.1166 0.508448 13.0932 0.490448 13.064C0.413673 12.9394 0.250458 12.9006 0.125884 12.9774C0.00129591 13.0541 -0.0374636 13.2173 0.0392988 13.3419C0.162679 13.5421 0.381099 13.6665 0.609315 13.6665C0.64461 13.6665 0.678206 13.6595 0.709001 13.647C1.03169 13.6028 1.28113 13.3255 1.28113 12.991C1.28113 12.8598 1.23444 12.7507 1.16842 12.6636C1.23241 12.5759 1.28113 12.4646 1.28113 12.3288C1.28113 11.9636 0.983968 11.6665 0.618726 11.6665Z"
          fill="white"
        />
        <path
          d="M1.08039 7.30016H0.891675C1.27655 6.85861 1.3269 6.64093 1.3269 6.50017C1.3269 6.13257 1.03141 5.8335 0.668191 5.8335C0.666607 5.8335 0.665075 5.83371 0.663518 5.83374C0.661934 5.83371 0.660416 5.8335 0.658845 5.8335C0.295641 5.8335 0.000138592 6.13256 0.000138592 6.50017C0.000138592 6.64744 0.118105 6.76683 0.263619 6.76683C0.409133 6.76683 0.527099 6.64744 0.527099 6.50017C0.527099 6.42791 0.587435 6.36684 0.658845 6.36684C0.660429 6.36684 0.66196 6.36663 0.663518 6.3666C0.665102 6.36663 0.66662 6.36684 0.668191 6.36684C0.73869 6.36684 0.798366 6.42633 0.799911 6.49738C0.797337 6.5111 0.764892 6.64846 0.45487 6.99446C0.271222 7.19945 0.0884844 7.36758 0.0867157 7.36921C0.00598607 7.44323 -0.0214166 7.55991 0.0177734 7.66278C0.0569635 7.76564 0.154668 7.8335 0.263605 7.8335H1.08039C1.22591 7.8335 1.34387 7.7141 1.34387 7.56683C1.34387 7.41956 1.22592 7.30016 1.08039 7.30016Z"
          fill="white"
        />
        <path
          d="M13.5 0.5H9H4.5C4.36739 0.5 4.24021 0.552678 4.14645 0.646447C4.05268 0.740215 4 0.867392 4 1C4 1.13261 4.05268 1.25979 4.14645 1.35355C4.24021 1.44732 4.36739 1.5 4.5 1.5H13.5C13.6326 1.5 13.7598 1.44732 13.8536 1.35355C13.9473 1.25979 14 1.13261 14 1C14 0.867392 13.9473 0.740215 13.8536 0.646447C13.7598 0.552678 13.6326 0.5 13.5 0.5Z"
          fill="white"
        />
        <path
          d="M13.5 6.5H9H4.5C4.36739 6.5 4.24021 6.55268 4.14645 6.64645C4.05268 6.74021 4 6.86739 4 7C4 7.13261 4.05268 7.25979 4.14645 7.35355C4.24021 7.44732 4.36739 7.5 4.5 7.5H13.5C13.6326 7.5 13.7598 7.44732 13.8536 7.35355C13.9473 7.25979 14 7.13261 14 7C14 6.86739 13.9473 6.74021 13.8536 6.64645C13.7598 6.55268 13.6326 6.5 13.5 6.5Z"
          fill="white"
        />
        <path
          d="M13.5 12.25H9H4.5C4.36739 12.25 4.24021 12.3027 4.14645 12.3964C4.05268 12.4902 4 12.6174 4 12.75C4 12.8826 4.05268 13.0098 4.14645 13.1036C4.24021 13.1973 4.36739 13.25 4.5 13.25H13.5C13.6326 13.25 13.7598 13.1973 13.8536 13.1036C13.9473 13.0098 14 12.8826 14 12.75C14 12.6174 13.9473 12.4902 13.8536 12.3964C13.7598 12.3027 13.6326 12.25 13.5 12.25Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_5793_60354">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  bulletList: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5793_60388)">
        <path
          d="M1.16675 2C1.71903 2 2.16675 1.55228 2.16675 1C2.16675 0.447715 1.71903 0 1.16675 0C0.614463 0 0.166748 0.447715 0.166748 1C0.166748 1.55228 0.614463 2 1.16675 2Z"
          fill="white"
        />
        <path
          d="M1.16675 7.8335C1.71903 7.8335 2.16675 7.38578 2.16675 6.8335C2.16675 6.28121 1.71903 5.8335 1.16675 5.8335C0.614463 5.8335 0.166748 6.28121 0.166748 6.8335C0.166748 7.38578 0.614463 7.8335 1.16675 7.8335Z"
          fill="white"
        />
        <path
          d="M1.16675 13.6665C1.71903 13.6665 2.16675 13.2188 2.16675 12.6665C2.16675 12.1142 1.71903 11.6665 1.16675 11.6665C0.614463 11.6665 0.166748 12.1142 0.166748 12.6665C0.166748 13.2188 0.614463 13.6665 1.16675 13.6665Z"
          fill="white"
        />
        <path
          d="M13.5 0.5H9H4.5C4.36739 0.5 4.24021 0.552678 4.14645 0.646447C4.05268 0.740215 4 0.867392 4 1C4 1.13261 4.05268 1.25979 4.14645 1.35355C4.24021 1.44732 4.36739 1.5 4.5 1.5H13.5C13.6326 1.5 13.7598 1.44732 13.8536 1.35355C13.9473 1.25979 14 1.13261 14 1C14 0.867392 13.9473 0.740215 13.8536 0.646447C13.7598 0.552678 13.6326 0.5 13.5 0.5Z"
          fill="white"
        />
        <path
          d="M13.5 6.5H9H4.5C4.36739 6.5 4.24021 6.55268 4.14645 6.64645C4.05268 6.74021 4 6.86739 4 7C4 7.13261 4.05268 7.25979 4.14645 7.35355C4.24021 7.44732 4.36739 7.5 4.5 7.5H13.5C13.6326 7.5 13.7598 7.44732 13.8536 7.35355C13.9473 7.25979 14 7.13261 14 7C14 6.86739 13.9473 6.74021 13.8536 6.64645C13.7598 6.55268 13.6326 6.5 13.5 6.5Z"
          fill="white"
        />
        <path
          d="M13.5 12.25H9H4.5C4.36739 12.25 4.24021 12.3027 4.14645 12.3964C4.05268 12.4902 4 12.6174 4 12.75C4 12.8826 4.05268 13.0098 4.14645 13.1036C4.24021 13.1973 4.36739 13.25 4.5 13.25H13.5C13.6326 13.25 13.7598 13.1973 13.8536 13.1036C13.9473 13.0098 14 12.8826 14 12.75C14 12.6174 13.9473 12.4902 13.8536 12.3964C13.7598 12.3027 13.6326 12.25 13.5 12.25Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_5793_60388">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
};

const activeListIcon = {
  none: 'defaultList',
  numbered: 'numberedList',
  bullet: 'bulletList',
};

export const EditorTools = React.memo(function EditorTools(): JSX.Element {
  const app = useTldrawApp();
  const selectedId = app.useStore((s) => s.document.pageStates.page.selectedIds);
  // currentstyle is needed to rerender on style change
  const currrentStyle = app.useStore((s) => s.appState.currentStyle);
  const currentAlign = app.getShape(selectedId[0]).style.textAlign || 'start';
  const currentList = app.getShape(selectedId[0]).style.listType || ListType.None;
  const toggleBold = () => {
    const textWeight = app.getShape(selectedId[0]).style.textWeight;
    app.style({
      textWeight: textWeight === 'normal' ? TextWeight.Bold : TextWeight.Normal,
    });
  };
  const toggleItalic = () => {
    const fontStyle = app.getShape(selectedId[0]).style.fontStyle;
    app.style({
      fontStyle: fontStyle === 'italic' ? 'normal' : 'italic',
    });
  };
  const toggleStrike = () => {
    const textDecoration = app.getShape(selectedId[0]).style.textDecoration;
    app.style({
      textDecoration:
        textDecoration === 'none' || textDecoration === 'underline' ? 'line-through' : 'none',
    });
  };
  const toggleUnderLine = () => {
    const textDecoration = app.getShape(selectedId[0]).style.textDecoration;
    app.style({
      textDecoration:
        textDecoration === 'none' || textDecoration === 'line-through' ? 'underline' : 'none',
    });
  };
  const incrementSize = () => {
    const scale = app.getShape(selectedId[0]).style.scale || 1;
    app.style({
      scale: scale + 0.1 * scale,
    });
  };
  const decrementSize = () => {
    const scale = app.getShape(selectedId[0]).style.scale || 1;
    app.style({
      scale: scale - 0.1 * scale,
    });
  };
  const bulletList = () => {
    app.style({
      listType: ListType.Bullet,
    });
  };
  const numberList = () => {
    app.style({
      listType: ListType.Numbered,
    });
  };
  const defaultList = () => {
    app.style({
      listType: ListType.None,
    });
  };
  const alignLeft = () => {
    app.style({
      textAlign: AlignStyle.Start,
    });
  };
  const alignCenter = () => {
    app.style({
      textAlign: AlignStyle.Middle,
    });
  };
  const alignRight = () => {
    app.style({
      textAlign: AlignStyle.End,
    });
  };

  return (
    <>
      <div className="flex gap-10 items-center cursor-pointer">
        <div onClick={incrementSize}>{editorIcons['fontIncrement']}</div>
        <div onClick={decrementSize}>{editorIcons['fontDecrement']}</div>
      </div>
      <div className=" text-gray-800">|</div>
      <div className="flex gap-10 items-center cursor-pointer">
        <div onClick={toggleBold}>{editorIcons['bold']}</div>
        <div onClick={toggleItalic}>{editorIcons['italic']}</div>
        <div onClick={toggleUnderLine}>{editorIcons['underline']}</div>
        <div onClick={toggleStrike}>{editorIcons['strike']}</div>
        <div className=" text-gray-800">|</div>
        <DropdownMenu.Root dir="ltr">
          <DropdownMenu.Trigger asChild>
            <div className="flex items-center gap-2 cursor-pointer">
              {editorIcons[currentAlign]}
              <ArrowUpIcon />
            </div>
          </DropdownMenu.Trigger>
          <DropdownMenu.Content
            className="flex flex-row items-center gap-8 py-2 justify-center bg-primary-900 rounded-sm cursor-pointer "
            style={{ padding: '4px 8px', transform: 'translate(1px,-56px)' }}
          >
            <DropdownMenu.Item>
              <div onClick={alignLeft}>{editorIcons.start}</div>
            </DropdownMenu.Item>
            <DropdownMenu.Item>
              <div onClick={alignCenter}> {editorIcons.middle}</div>
            </DropdownMenu.Item>
            <DropdownMenu.Item>
              <div onClick={alignRight}>{editorIcons.end}</div>
            </DropdownMenu.Item>
          </DropdownMenu.Content>
        </DropdownMenu.Root>
        <div className=" text-gray-800">|</div>
        <DropdownMenu.Root dir="ltr">
          <DropdownMenu.Trigger asChild>
            <div className="flex items-center gap-2 cursor-pointer">
              {editorIcons[activeListIcon[currentList]]}
              <ArrowUpIcon />
            </div>
          </DropdownMenu.Trigger>
          <DropdownMenu.Content
            className="flex flex-row items-center gap-8 py-2 justify-center bg-primary-900 rounded-sm cursor-pointer "
            style={{ padding: '4px 8px', transform: 'translate(1px,-56px)' }}
          >
            <DropdownMenu.Item>
              <div onClick={bulletList}>{editorIcons.bulletList}</div>
            </DropdownMenu.Item>
            <DropdownMenu.Item>
              <div onClick={numberList}> {editorIcons.numberedList}</div>
            </DropdownMenu.Item>
            <DropdownMenu.Item>
              <div onClick={defaultList}>{editorIcons.defaultList}</div>
            </DropdownMenu.Item>
          </DropdownMenu.Content>
        </DropdownMenu.Root>
      </div>
    </>
  );
});
